<script setup lang="ts">
const { elementReference, isReady, isRevealed } = useScrollReveal()
</script>

<template>
  <div
    id="intro"
    ref="elementReference"
    :class="['px-0 py-0 mx-0 my-0', { reveal: isReady, revealed: isRevealed }]"
  >
    <div class="pt-high">
      <v-row align="center">
        <!-- <v-col cols="12" lg="6" class="pb-8 pb-lg-0">
          <v-img :class="imageLoaded ? 'image-visible' : 'image-invisible'" src="/images/team.webp" alt="Team" @load="imageLoaded = true" />
        </v-col> -->
        <v-col cols="12" lg="12" class="px-8 px-lg-16">
          <h2 class="text-primary bannerTitle font-weight-regular mb-8">Referenzen</h2>
          <p class="text-body-1 mb-4">
            Willkommen in der Galerie unserer Arbeit – eine Sammlung von Projekten. Als Architekten
            haben wir im Laufe der Jahre mit Leidenschaft und Hingabe an zahlreichen Projekten
            gearbeitet, hier ist eine Auswahl die die Bedürfnisse unserer Kunden widerspiegelt.
          </p>
          <p class="text-body-1 mb-4">
            Diese Referenzen bieten einen faszinierenden Einblick in unsere Vielseitigkeit und
            Innovationskraft. Von imposanten Gewerbebauten über anspruchsvolle
            Geschosswohnungsbauten bis hin zu inspirierenden Bildungsgebäuden – jedes Projekt trägt
            die charakteristische Handschrift unserer kreativen Expertise.
          </p>
          <p class="text-body-1">
            Durch eine Kombination aus Ästhetik, Funktionalität und einem tiefen Verständnis für die
            individuellen Anforderungen jedes Auftraggebers haben wir nicht nur Gebäude geschaffen,
            sondern Lebensräume, die den Alltag transformieren und eine bleibende Wirkung
            hinterlassen.
          </p>
        </v-col>
      </v-row>
    </div>
  </div>
</template>
